import { request } from './request'

export interface AdminStore {
  id: string
  name: string
  imageUrl?: string
  category?: string
  categories?: string[]
  code: string
  address?: string
  phone?: string
  longitude?: number | string
  latitude?: number | string
  businessStatus: string
  supportsDelivery?: boolean
  supportsDrone?: boolean
  openTime?: string
  closeTime?: string
  createdAt?: string
}

export interface StoreStats {
  storeId: string
  todayOrderCount: number
  todayRevenue: number
  monthOrderCount: number
  monthRevenue: number
}

export interface StoreListParams {
  keyword?: string
  status?: string
}

export interface StoreSettingsPayload {
  openTime?: string
  closeTime?: string
  suspendOrdering?: boolean
  suspendReason?: string
  pickupPrepareMinutes?: number
  deliveryPrepareMinutes?: number
}

export interface StoreSavePayload {
  id?: string
  name: string
  imageUrl?: string
  category?: string
  categories?: string[]
  code?: string
  address?: string
  phone?: string
  longitude?: number
  latitude?: number
  businessStatus?: string
  supportsDelivery?: boolean
  supportsDrone?: boolean
  openTime?: string
  closeTime?: string
}

export const storeApiReady = true as const

export const fetchStores = async (params: StoreListParams): Promise<AdminStore[]> =>
  request<AdminStore[]>({
    url: '/stores',
    method: 'GET',
    params,
  })

export const createStore = async (payload: StoreSavePayload): Promise<void> =>
  request<void, StoreSavePayload>({
    url: '/stores',
    method: 'POST',
    data: payload,
  })

export const updateStore = async (payload: StoreSavePayload): Promise<void> => {
  if (!payload.id) throw new Error('缺少门店 id')
  return request<void, StoreSavePayload>({
    url: `/stores/${payload.id}`,
    method: 'PUT',
    data: payload,
  })
}

export const deleteStore = async (id: string): Promise<void> =>
  request<void>({
    url: `/stores/${id}`,
    method: 'DELETE',
  })

export const fetchStoreStats = async (id: string): Promise<StoreStats> =>
  request<StoreStats>({
    url: `/stores/${id}/stats`,
    method: 'GET',
  })

export const updateStoreSettings = async (
  id: string,
  payload: StoreSettingsPayload,
): Promise<void> =>
  request<void, StoreSettingsPayload>({
    url: `/stores/${id}/settings`,
    method: 'PUT',
    data: payload,
  })
